"use client";

import CTAFooter from "@/components/Footer/CTAFooter";
import ProjectHeader from "@/components/pages/project/sections/ProjectHeader";
import ProjectNumbers from "@/components/pages/project/sections/ProjectNumbers";
import PageHeader from "./PageHeader";

import ColumnRow from "./ColumnRow";
import FormSection from "./FormSection";
import Paragraph from "./Paragraph";
import { SectionTitle } from "@/components/SectionTitle";
import { ScrollingText } from "@/components/ScrollingText";
import { util } from "@/common/theme";
import styled from "styled-components";
import { useMemo } from "react";
import { useGlobalStore } from "mono/store/global";
import { mediaMobile } from "mono/lib/responsive";

function ScrollingTitle({ data: { text } }) {
  const isMobileLayout = useGlobalStore((state) => state.isMobileLayout);

  const maxWidth = useMemo(() => {
    if (isMobileLayout) {
      return "100vw";
    }
    return "50vw";
  }, [isMobileLayout]);

  return (
    <ScrollingTitleWrapper>
      <ScrollingText maxWidth={maxWidth}>{text}</ScrollingText>
    </ScrollingTitleWrapper>
  );
}

export const ContentComponents = {
  ProjectheaderRecord: ProjectHeader,
  ProjectnumberRecord: ProjectNumbers,
  PageheaderRecord: PageHeader,

  ParagraphRecord: Paragraph,
  ColumnrowRecord: ColumnRow,
  ScrollingTitleRecord: ScrollingTitle,
  SectionlineRecord: ({ data: { title } }) => (
    <SectionTitle>{title}</SectionTitle>
  ),
  CtasectionRecord: ({ data }) => (
    <CTAFooter
      title={data.title?.replace(/<\/?p>/g, "")}
      cta={{ href: data.ctaLink, text: data.ctaText }}
    />
  ),
  FormSectionRecord: ({ data }) => <FormSection data={data} />,
};

const ScrollingTitleWrapper = styled.div`
  ${util.inner}
  padding-bottom: 50rem !important;

  ${mediaMobile(`
    padding-bottom: 0rem !important;
  `)}
`;
